import keyBy from 'lodash-es/keyBy';
import omit from 'lodash-es/omit';
import { DisplayActionTypes, DisplaysActionKeys as keys, IDisplayConfig } from '.';

export interface IDisplaysState {
  configHash: { [index: string]: IDisplayConfig };
}

const initState: IDisplaysState = {
  configHash: {}
};

export function displaysReducer(state: IDisplaysState = initState, action: DisplayActionTypes): IDisplaysState {
  switch (action.type) {
    case keys.REMOVE_DISPLAY_CONFIG:
      return {
        ...state,
        configHash: omit(state.configHash, action.payload.userSid)
      };
    case keys.SET_DISPLAY_CONFIGS:
      return {
        ...state,
        configHash: { ...state.configHash, ...keyBy(action.payload, (c: IDisplayConfig) => c.userSid) }
      };
    default:
      return state;
  }
}
